const getters = {
    language: state => state.app.language,
	size: state => state.app.size,
}

export default getters


// WEBPACK FOOTER //
// ./src/store/getters.js